// extracted by mini-css-extract-plugin
module.exports = {"highValueLabel":"dealSortOptions_highValueLabel__77Owq","highValueStar":"dealSortOptions_highValueStar__uI15J"};